<template>
  <error v-if="error" :error="error" />
  <div id="profile" class="card card-body mt-4">
    <div class="row justify-content-center align-items-center">
      <div class="col-sm-auto col-4">
        <div class="avatar avatar-xl">
          <img :src="isLoading ? loadingImageUrl : profileImageSrc" alt="User Image" class="shadow-sm rounded-circle" />
        </div>
      </div>
      <div class="col-sm-auto col-8 my-auto">
        <div class="h-100">
          <h5 class="mb-1 font-weight-bolder">{{ state.user.fullname }}</h5>
          <p class="mb-0 font-weight-bold text-sm">            
            {{ $t(`common.${state.user.roleName}`) }}
            <material-badge v-if="state.user.active" color="success" size="sm"
              class="my-auto ms-auto me-3">{{ $t('user.Active') }}</material-badge>
            <material-badge v-if="!state.user.active" color="danger" size="sm" class="my-auto ms-auto me-3">Not active</material-badge>
          </p>
        </div>
      </div>
      <div class="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">
      </div>
    </div>
  </div>
  <div id="user-info" class="card mt-4">
    <div class="card-header">
      <h5>{{ $t('user.User_info') }}</h5>
      <p class="mb-0 text-sm">{{ $t('user.Mandatory_informations') }} *</p>
    </div>
    <div class="card-body pt-0">
      <div class="row">
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Username') }}</label>
            <input v-model="state.userName" type="text" class="form-control form-control-default" disabled>
          </div>
        </div>
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.E-mail') }} *</label>
            <input v-model="state.email" type="text" class="form-control form-control-default"
              :placeholder="$t('user.E-mail')">
            <span v-if="vrulesUserDetails$.email.$error" class="text-sm text-danger">
              {{ vrulesUserDetails$.email.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Initials') }}</label>
            <input v-model="state.initials" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Initials')">            
          </div>
        </div>
        <!--
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Prefix') }}</label>
            <input v-model="state.prefix" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Prefix')">            
          </div>
        </div>
      -->
      </div>
      <div class="row mt-4">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Firstname') }}</label>
            <input v-model="state.firstName" type="text" class="form-control form-control-default" :placeholder="$t('user.Firstname')">            
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Middlename') }}</label>
            <input v-model="state.middleName" type="text" class="form-control form-control-default" :placeholder="$t('user.Middlename')">            
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Lastname') }} *</label>
            <input v-model="state.lastName" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Lastname')">
            <span v-if="vrulesUserDetails$.lastName.$error" class="text-sm text-danger">
              {{ vrulesUserDetails$.lastName.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Phone_number') }}</label>
            <input v-model="state.phoneNumber" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Phone_number')">
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Mobile_number') }}</label>
            <input v-model="state.mobileNumber" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Mobile_number')">
            <!--<span v-if="vrulesUserDetails$.mobileNumber.$error" class="text-sm text-danger">
              {{ vrulesUserDetails$.mobileNumber.$errors[0].$message }}
            </span>-->
          </div>
        </div>
        <div class="col-4" v-show="state.roleName === 'Keeper'">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Studbookcode') }}</label>
            <input v-model="state.studbookCode" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Studbookcode')">
          </div>
        </div>
      </div>
      <div class="row mt-4" v-show="state.roleName === 'Keeper'">
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Inspector') }} *</label>
            <select id="inspectorId" v-model="state.inspectorId" class="form-control form-control-default">
              <option value="">{{ $t('user.Select_inspector') }}</option>
              <option v-for="inspector in state.inspectors" :key="inspector.id" :value="inspector.id">
                {{ inspector.fullname }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row mt-4" v-show="state.roleName === 'Keeper' || state.roleName === 'Inspector'">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.User_start_date') }}</label>
            <input v-model="state.userStartDate" type="date" :max="todayDate" class="form-control form-control-default"
              :placeholder="$t('user.User_start_date')">
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.User_end_date') }}</label>
            <input v-model="state.userEndDate" type="date" class="form-control form-control-default"
              :placeholder="$t('user.User_end_date')">
          </div>
        </div>
      </div>
      <div class="row mt-4" v-show="state.roleName === 'Keeper'">
        <div class="col-3">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('user.ShareName') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="state.shareName" id="shareName" name="shareName" />
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('user.ShareEmail') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="state.shareEmail" id="shareEmail" name="shareEmail" />
            </div>
          </div>
        </div>
        <!--
        <div class="col-3">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('user.ShareAddress') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="state.shareAddress" id="shareEmail" name="shareAddress" />
            </div>
          </div>
        </div>
        -->        
        <div class="col-3">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('user.ShareTelephone') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="state.shareTelephone" id="shareTelephone" name="shareTelephone" />
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4" v-show="state.roleName === 'Keeper'">
        <div class="col-3">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('user.RVO_Connection') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="state.rvoConnection" id="rvoConnection" name="rvoConnection" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.RVO_Relationnumber') }}</label>
            <input v-model="state.rvoRelationnumber" type="text" class="form-control form-control-default"
              :placeholder="$t('user.RVO_Relationnumber')">
          </div>
        </div>
        <div class="col-3">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">{{ $t('user.GD_Connection') }}</label>
            <div class="d-block mt-1">
              <material-switch v-model="state.gdConnection" id="gdConnection" name="gdConnection" />
            </div>
          </div>
        </div>
      </div>      
      <div class="col-12 col-sm-12 mt-6">
        <button v-on:click="updateUserInfo" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Update_contact_info') }}</button>
      </div>
    </div>
  </div>
  <div id="address" class="card mt-4">
    <div class="card-header">
      <h5>{{ $t('user.Address') }}</h5>
    </div>
    <div class="card-body pt-0">
      <div class="row">
        <div class="col-8">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Address') }} *</label>
            <input v-model="state.address" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Address')">
            <span v-if="vAddress$.address.$error" class="text-sm text-danger">
              {{ vAddress$.address.$errors[0].$message }}
            </span>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.House_number') }} *</label>
            <input v-model="state.houseNumber" type="text" class="form-control form-control-default"
              :placeholder="$t('user.House_number')">
            <span v-if="vAddress$.houseNumber.$error" class="text-sm text-danger">
              {{ vAddress$.houseNumber.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Zipcode') }} *</label>
            <input v-model="state.zipcode" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Zipcode')">
            <span v-if="vAddress$.zipcode.$error" class="text-sm text-danger">
              {{ vAddress$.zipcode.$errors[0].$message }}
            </span>
          </div>
        </div>      
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.City') }} *</label>
            <input v-model="state.city" type="text" class="form-control form-control-default"
              :placeholder="$t('user.City')">
            <span v-if="vAddress$.city.$error" class="text-sm text-danger">
              {{ vAddress$.city.$errors[0].$message }}
            </span>
          </div>
        </div>        
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('user.Country') }} *</label>
            <input v-model="state.country" type="text" class="form-control form-control-default"
              :placeholder="$t('user.Country')">
            <span v-if="vAddress$.country.$error" class="text-sm text-danger">
              {{ vAddress$.country.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 mt-6">
        <button v-on:click="updateAddress" class="btn btn-sm bg-gradient-success mr-2 float-end">{{
          $t('user.Update_address') }}</button>
      </div>
    </div>
  </div>
  <div id="password" class="card mt-4">
    <div class="card-header">
      <h5 class="font-weight-bolder">{{ $t('user.Password') }}</h5>
      <p class="mb-0 text-sm">{{ $t('user.Password_rule') }}</p>
      <p class="mb-0 text-sm">{{ $t('user.Mandatory_informations') }} *</p>
    </div>
    <div class="card-body pt-0">   
      <div class="row">
        <div class="col-6">
          <div class="row mt-4">
            <div class="col-12">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('user.New_password') }} *</label>
                <input :type="show.new ? 'text' : 'password'" class="password-input" v-model.trim="password" id="password" isrequired="true" @input="validateAll">
                <span class="material-symbols-outlined toggle-icon" @click="toggle('new')">{{ !show.new ? 'visibility' : 'visibility_off' }}</span>              
                <span v-if="password && !allValidationsOk" class="text-sm text-danger">{{ $t('user.New_password_value_is_invalid') }}</span>                  
              </div>
            </div>
          </div>
          <div class="row mt-6">
            <div class="col-12">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('user.Repeat_new_password') }} *</label>
                <input :type="show.confirm ? 'text' : 'password'" class="password-input" v-model.trim="confirmPassword" id="confirmPassword" isrequired="true" @input="validateAll">
                <span class="material-symbols-outlined toggle-icon" @click="toggle('confirm')">{{ !show.confirm ? 'visibility' : 'visibility_off' }}</span>              
                <span v-if="confirmPassword && !passwordsMatch" class="text-sm text-danger">{{ $t('user.Passwords_do_not_match') }}</span>                  
              </div>
            </div>
          </div>            
        </div>
        <div class="col-6">
            <ul class="checklist">
              <li :class="{ok: validations.lengthOk}">
                <Icon :ok="validations.lengthOk" /> {{ $t('user.Longer_than_7_characters') }}
              </li>
              <li :class="{ok: validations.hasUpper}">
                <Icon :ok="validations.hasUpper" /> {{ $t('user.Contains_a_capital_letter') }}
              </li>
              <li :class="{ok: validations.hasLower}">
                <Icon :ok="validations.hasLower" /> {{ $t('user.Contains_a_lowercase_letter') }}
              </li>
              <li :class="{ok: validations.hasDigit}">
                <Icon :ok="validations.hasDigit" /> {{ $t('user.Contains_a_number') }}
              </li>
              <li :class="{ok: validations.hasSpecial}">
                <Icon :ok="validations.hasSpecial" /> {{ $t('user.Contains_a_special character') }}
              </li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-sm-12 mt-6">
        <button v-on:click="updatePassword" class="btn btn-sm bg-gradient-success mr-2 float-end" :disabled="!canSubmit">{{ $t('user.Update_password') }}</button>                                                    
      </div>        
    </div>    
  </div>
  <div id="sessions" class="card mt-4">
    <div class="card-header pb-3">
      <h5>Sessions</h5>
      <p class="text-sm">
        This is a list of devices that have logged into your account.
      </p>
    </div>
    <!--
    <div class="card-body pt-0" v-for="(userAction, index) in userActions" v-bind:key="userAction.id">
      <div class="d-flex align-items-center">
        <div class="text-center w-5">
          <i class="fas fa-desktop text-lg opacity-6" v-if="userAction.deviceType === 'Desktop'"></i>
          <i class="fas fa-mobile text-lg opacity-6" v-else></i>
        </div>
        <div class="my-auto ms-3">
          <div class="h-100">
            <p class="text-xs mb-1">{{ userAction.userAgent }} <br> {{ userAction.userHostIp }}</p>
            <material-badge v-if="index === 0" color="success" size="sm"
              class="my-auto ms-auto me-3">Active</material-badge>
          </div>
        </div>
        <p class="mb-0 text-xs ms-auto me-3" style="text-align: right;">{{ formatDate(userAction.dateTimeStamp) }}</p>
      </div>
    </div>
    -->
  </div>
  
  <div class="row mt-4">
    <div class="col-md-6">
      <div id="profileimage" class="card mt-4" data-animation="FadeIn">
        <div class="row align-items-center justify-content-between">
          <div class="col">
            <div class="card-header pb-3">
              <h5>{{ $t('user.Profile_image') }}</h5>
              <p class="mb-0 text-sm">
                {{ $t('user.Optional_information') }} ({{ $t('user.Upload_profile_image') }})
              </p>
            </div>
          </div>
          <div class="col-auto" style="margin-right: 25px;  margin-top: 10px;">
            <div class="avatar avatar-xl">
              <img :src="isLoading ? loadingImageUrl : profileImageSrc" :alt="$t('user.Profile_image')"
                class="shadow-sm" />
            </div>
          </div>
        </div>
        <div class="card-body pt-0">
          <div class="row mt-2">
            <div class="col-12">
              <div id="profileImg" class="form-control border dropzone"></div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <button v-on:click="updateProfileImage" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('user.Upload_profile_image') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6" v-show="state.roleName === 'AssociationAdmin'">
      <div id="signatureimage" class="card mt-4" data-animation="FadeIn">
        <div class="row align-items-center justify-content-between">
          <div class="col">
            <div class="card-header pb-3">
              <h5>{{ $t('user.Signature_image') }}</h5>
              <p class="mb-0 text-sm">
                {{ $t('user.Optional_information') }} ({{ $t('user.Upload_signature_image') }})
              </p>
            </div>
          </div>
          <div class="col-auto" style="margin-right: 25px;  margin-top: 10px;">
            <div class="avatar avatar-xl">
              <img :src="isLoading ? loadingImageUrl : associationSignatureImageSrc" :alt="$t('user.Signature_image')"
                class="shadow-sm" />
            </div>
          </div>
        </div>
        <div class="card-body pt-0">
          <div class="row mt-2">
            <div class="col-12">
              <div id="signatureImg" class="form-control border dropzone"></div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <button v-on:click="uploadSignatureImage" class="btn btn-sm bg-gradient-success mr-2 float-end">{{
                $t('user.Upload_signature_image') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="delete" class="card mt-4">
    <div class="card-header">
      <h5>{{ $t('user.Delete_account') }}</h5>
      <p class="text-sm mb-0" v-if="state.canDelete">
        {{ $t('user.Once_you_delete_your_account_there_is_no_going_back_please_be_certain') }}
      </p>
    </div>
    <div class="card-body d-sm-flex pt-0" v-if="state.canDelete">
      <div class="d-flex align-items-center mb-sm-0 mb-4">
        <div>
          <material-switch id="deleteAccount" name="Delete Account" @click="confirmDelete" />
        </div>
        <div class="ms-2">
          <span class="text-dark font-weight-bold d-block text-sm">{{ $t('user.Confirm') }}</span>
          <span class="text-xs d-block">{{ $t('user.Delete_account_for') }} {{ state.user.fullname }}.</span>
        </div>
      </div>
      <!--<button class="btn mb-0 btn-outline-secondary btn-sm null null mb-0 ms-auto" type="button"
        @click="deactivateAccount" name="button">Deactivate</button>-->
      <button class="btn mb-0 bg-gradient-danger btn-sm null null mb-0 ms-2" type="button"
        :disabled="!state.deleteUserAccount" @click="deleteAccount" name="button">{{ $t('user.Delete_account') }}</button>
    </div>
    <div class="card-body d-sm-flex pt-0" v-if="!state.canDelete">
      <div class="d-flex align-items-center mb-sm-0 mb-4">        
        <div>
          <p class="text-sm mb-0">
            {{ $t('user.Account_cannot_be_deleted') }}
          </p>
        </div>
      </div>      
    </div>
  </div>
</template>

<script>
import MaterialBadge from "@/components/MaterialBadge.vue";
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import Dropzone from "dropzone";
import axios from 'axios'
import useValidate from '@vuelidate/core'
import { required, email as emailValidator, helpers, } from '@vuelidate/validators'
import { reactive, computed } from 'vue'
import loadingImageUrl from "@/assets/img/LoadingImage.gif";
import { useI18n } from 'vue-i18n';
import * as Choices from "choices.js";
import { h } from 'vue';
import { mapMutations } from 'vuex';

const Icon = {
  name: 'Icon',
  props: { ok: { type: Boolean, default: false } },
  render() {
    if (this.ok) {
      return h('svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          width: '16',
          height: '16',
          viewBox: '0 0 24 24',
          'aria-hidden': 'true'
        },
        [
          h('path', {
            fill: '#1aa34a',
            d: 'M9 16.2l-3.5-3.5-1.4 1.4L9 19 20 8l-1.4-1.4z'
          })
        ]
      );
    } else {
      return h('svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          width: '16',
          height: '16',
          viewBox: '0 0 24 24',
          'aria-hidden': 'true'
        },
        [
          h('path', {
            fill: '#d33',
            d: 'M12 10.6l4.9-4.9 1.4 1.4L13.4 12l4.9 4.9-1.4 1.4L12 13.4l-4.9 4.9-1.4-1.4L10.6 12 5.7 7.1 7.1 5.7 12 10.6z'
          })
        ]
      );
    }
  }
};

export default {
  name: "UserDetailItem",
  emits: ['user-loaded'],
  setup() {

    const { t } = useI18n()
    const todayDate = new Date().toISOString().split('T')[0];
    const state = reactive({
      user: [],
      userActions: [],
      userId: '',

      userName: '',
      initials: '',
      //prefix: '',
      firstName: '',
      middleName: '',
      lastName: '',
      mobileNumber: '',
      active: false,
      canDelete: false,
      email: '',
      phoneNumber: '',
      inspectorId: '',
      id: '',
      shareTelephone: false,
      shareAddress: false,
      shareEmail: false,
      shareName: false,
      rvoConnection: false,
      rvoRelationnumber: '',
      gdConnection: false,
      studbookCode: '',
      user_StartDate: null,
      user_EndDate: null,
      address: '',
      houseNumber: '',
      city: '',
      zipcode: '',
      country: '',
      aspNetUserId: '',
      roleName: '',
      inspectorFirstName: '',
      inspectorLastName: '',
      associationId: '',
      associationName: '',

      inspectorFullname: '',
      fullAddress: '',
      fullname: '',

      image: null,
      signatureImage: null,
      inspectors: [],
      associations: [],
      
      deleteUserAccount: false,
    })

    const rulesUserDetails = computed(() => ({      
      lastName: { required: helpers.withMessage(t('common.Required'), required) },
      //mobileNumber: { required: helpers.withMessage(t('common.Required'), required) },      
      email: {
        required: helpers.withMessage(t('common.Required'), required),
        email: helpers.withMessage(t('common.Invalid_email_address'), emailValidator)
      }      
    }))

    const rulesAddress = computed(() => ({
      houseNumber: { required: helpers.withMessage(t('common.Required'), required) },
      address: { required: helpers.withMessage(t('common.Required'), required) },
      city: { required: helpers.withMessage(t('common.Required'), required) },
      zipcode: { required: helpers.withMessage(t('common.Required'), required) },
      country: { required: helpers.withMessage(t('common.Required'), required) }
    }))

    const vrulesUserDetails$ = useValidate(rulesUserDetails, state)
    const vAddress$ = useValidate(rulesAddress, state)

    return {
      state,
      vAddress$,
      vrulesUserDetails$,
      todayDate
    }
  },
  components: {
    Icon,
    MaterialBadge,
    MaterialSwitch,
  },
  data() {
    return {      
      deleteUserAccount: false,
      isLoading: true,
      loadingImageUrl,
      password: '',
      confirmPassword: '',  
      validations: {
        lengthOk: false,
        hasUpper: false,
        hasLower: false,
        hasDigit: false,
        hasSpecial: false
      },
      show: {
        current: false,
        new: false,
        confirm: false
      }
    };
  },
  async mounted() {
    try {
      this.userId = this.$route.params.userId;

      this.initializeDropzoneProfile();
      this.initializeDropzoneSignature();

      this.$store.commit('setShowLoading', true);

      const id = this.$route.params.id || this.userId;
      if (id) {
        await this.fetchUserData(id);
      } else {
        console.warn('No user ID found in route params');
      }
    } catch (e) {
      const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
      this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
    } finally {
      this.$store.commit('setShowLoading', false);
    }    
  },
  computed: {
      allValidationsOk() {
        const v = this.validations;
        return v.lengthOk && v.hasUpper && v.hasLower && v.hasDigit && v.hasSpecial;
      },
      canSubmit() {      
        const v = this.validations;
        return (
          v.lengthOk &&
          v.hasUpper &&
          v.hasLower &&
          v.hasDigit &&
          v.hasSpecial &&
          this.passwordsMatch
        );
      },
      passwordsMatch() {      
        return (
          this.password &&
          this.confirmPassword &&
          this.password === this.confirmPassword
        );
      },
  }, 
  methods: {
    
    ...mapMutations(['toggleEveryDisplay', 'toggleHideConfig']),

    toggle(which) {
      if (which in this.show) {
        this.show[which] = !this.show[which];
      }
    },

    validateAll() {
      const pwd = this.password || '';
      this.validations.lengthOk = pwd.length >= 8;
      this.validations.hasUpper = /[A-ZÀ-ÖØ-Þ]/.test(pwd);
      this.validations.hasLower = /[a-zà-öø-ÿ]/.test(pwd);
      this.validations.hasDigit = /[0-9]/.test(pwd);
      this.validations.hasSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(pwd);
    },

    initializeDropzoneProfile() {
      const vm = this; // Store reference to the Vue component instance

      this.dropzoneProfileImageInstance  = new Dropzone("#profileImg", {
        url: "/file-upload", // Not used, but Dropzone requires it
        maxFiles: 1,
        maxFilesize: 5, // in MB
        acceptedFiles: "image/*",
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictDefaultMessage: "Sleep bestanden hierheen om te uploaden",
        dictRemoveFile: "Verwijder bestand", 
      });

      this.dropzoneProfileImageInstance.on("addedfile", function(file) {
        vm.fileAdded = true;
        vm.selectedFile = file;
        console.log("File added:", file);
      });
    },
    initializeDropzoneSignature() {
      const vm = this; // Store reference to the Vue component instance

      this.dropzoneSignatureInstance  = new Dropzone("#signatureImg", {
        url: "/file-upload", // Not used, but Dropzone requires it
        maxFiles: 1,
        maxFilesize: 5, // in MB
        acceptedFiles: "image/*",
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictDefaultMessage: "Sleep bestanden hierheen om te uploaden",
        dictRemoveFile: "Verwijder bestand", 
      });

      this.dropzoneSignatureInstance .on("addedfile", function(file) {
        vm.fileAdded = true;
        vm.selectedFile = file;
        console.log("File added:", file);
      });
    },
    async fetchAllInspectorData() {
      try {
          const response = await axios.get("user/getuser?role=inspector");
          const result = response.data;

          if (result.success && Array.isArray(result.data.userList)) {
              this.state.inspectors = result.data.userList;

              // Wait for DOM to update
              this.$nextTick(() => {
                  this.initializeChoicesInspector(); // Initialize Choices here
              });
          } else {
            this.$showError('errors.Error_fetching_inspectors');              
          }
      } catch (e) {                    
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      }
    },
    initializeChoicesInspector() {
      const element = document.getElementById("inspectorId");

      if (!element || element.tagName !== "SELECT") {
          console.error("Choices: Invalid or missing select element.");
          return;
      }

      if (this.choicesInstanceInspector) {
          this.choicesInstanceInspector.destroy();
      }
      
      this.choicesInstanceInspector = new Choices(element, {
          searchEnabled: true,
          itemSelectText: '',
          shouldSort: false,
          placeholder: true, 
          //placeholderValue: '-- Select inspector --', 
      });        
      
      if (this.state.inspectorId) {
          const optionExists = this.state.inspectors.some(inspector => inspector.id === this.state.inspectorId);
          if (optionExists) {
              this.choicesInstanceInspector.setChoiceByValue([this.state.inspectorId]); // Set the selected value
          } else {
              this.choicesInstanceInspector.setChoiceByValue(''); // Clear if no match found
          }
      }
    },    
    async fetchUserData(userId) {
      try {

        const response = await axios.get(`User/userdetail/${userId}`);
        this.gets = response.data;

        if (this.gets.success) {
          this.state.user = this.gets.data.user;
          this.userActions = this.gets.data.userActions;

          // Send the complete user object, including UBNs, to the parent
          this.$emit('user-loaded', this.state.user);

          this.state.userName = this.state.user.userName;
          //this.state.prefix = this.state.user.prefix;
          this.state.initials = this.state.user.initials;
          this.state.firstName = this.state.user.firstName;
          this.state.middleName = this.state.user.middleName;
          this.state.lastName = this.state.user.lastName;
          this.state.mobileNumber = this.state.user.mobileNumber;
          this.state.active = this.state.user.active;
          this.state.canDelete = !!this.state.user.canDelete;
          this.state.email = this.state.user.email;
          this.state.phoneNumber = this.state.user.phoneNumber;
          this.state.inspectorId = this.state.user.inspectorId;
          this.state.id = this.state.user.id;
          this.state.shareTelephone = this.state.user.shareTelephone;
          this.state.shareAddress = this.state.user.shareAddress;
          this.state.shareEmail = this.state.user.shareEmail;
          this.state.shareName = this.state.user.shareName;
          this.state.rvoConnection = this.state.user.rvoConnection;
          this.state.rvoRelationnumber = this.state.user.rvoRelationnumber;
          this.state.gdConnection = this.state.user.gdConnection;
          this.state.studbookCode = this.state.user.studbookCode;
          this.state.userStartDate = this.state.user.userStartDate;
          this.state.userEndDate = this.state.user.userEndDate;
          this.state.address = this.state.user.address;
          this.state.houseNumber = this.state.user.houseNumber;
          this.state.city = this.state.user.city;
          this.state.zipcode = this.state.user.zipcode;
          this.state.country = this.state.user.country;
          this.state.aspNetUserId = this.state.user.aspNetUserId;
          this.state.roleName = this.state.user.roleName;
          this.state.inspectorFirstName = this.state.user.inspectorFirstName;
          this.state.inspectorLastName = this.state.user.inspectorLastName;
          this.state.associationId = this.state.user.associationId;
          this.state.associationName = this.state.user.associationName;

          this.state.inspectorFullname = this.state.user.inspectorFullname;
          this.state.fullAddress = this.state.user.fullAddress;
          this.state.fullname = this.state.user.fullname;


          await this.fetchUserImage();
          await this.fetchAllInspectorData();

        } else {
          this.$showError('errors.Contact_system_admin');          
        }
      } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      }      
    },
    async fetchUserImage() {
      try {
          this.isLoading = true;

          try {
            const responseProfileImage = await axios.get(`user/getprofileimage/`, {
              params: { aspNetUserId: this.state.aspNetUserId },
              responseType: 'blob',
            });

            const imageLogoBlob = responseProfileImage.data;
            this.profileImageSrc = URL.createObjectURL(imageLogoBlob);

          } catch (error) {            
            console.error('Failed to fetch logo image:', error);
          }

          // Fetch signature image only for AssociationAdmin
          if (this.state.roleName === 'AssociationAdmin') {          
            try {
              const responseSignature = await axios.get(`user/getsignatureimage/`, {
                params: { id: this.state.id },
                responseType: 'blob',
              });

              const contentTypeSignature = responseSignature.headers['content-type'];

              if (!contentTypeSignature.startsWith('image/')) {
                this.associationSignatureImageSrc = require('@/assets/no-image.png');
                return;
              }

              const imageSignatureBlob = responseSignature.data;
              this.associationSignatureImageSrc = URL.createObjectURL(imageSignatureBlob);

            } catch (error) {
              this.associationSignatureImageSrc = require('@/assets/no-image.png');
              console.error('Failed to fetch logo image:', error);
            }
          }
        } finally {
              this.isLoading = false; // Set loading state to false after fetching
        }
    },
    async updateProfileImage() {

        this.$store.commit('setShowLoading', true);

        const files = this.dropzoneProfileImageInstance.getQueuedFiles();

        if (files.length > 0) {
          const file = files[0]; // Since maxFiles is set to 1, we take the first file
          const formData = new FormData();
          formData.append('image', file);
          formData.append('userId', this.state.id);

          try {
            const response = await axios.put('user/updateimage', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
            console.log('Image uploaded successfully:', response.data);
            this.dropzoneProfileImageInstance.removeAllFiles(); // Clear Dropzone after successful upload
            this.fileAdded = false; // Reset the file added flag

            this.$showSuccess('errors.Success_image_updated_successfully');

            this.$router.push({ path: `/user/edit/${this.state.id}` }).then(() => {
              this.fetchUserData(this.state.id); 
            });

          } catch (error) {
            console.error('Error uploading image:', error);
            this.$showError('errors.Contact_system_admin');
          }
        } else {
          console.error('No image selected for upload.');
          this.$showError('errors.No_image_selected_for_upload');          
        }

        this.$store.commit('setShowLoading', false);
    }, 
    async uploadSignatureImage() {
      this.$store.commit('setShowLoading', true);
      const files = this.dropzoneSignatureInstance.getQueuedFiles();

      if (files.length > 0) {
        const file = files[0];
        const formData = new FormData();
        formData.append('image', file);
        formData.append('userId', this.state.id);

        try {
          const response = await axios.put('user/updatesignature', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          console.log('Image uploaded successfully:', response.data);
          this.dropzoneSignatureInstance.removeAllFiles(); // Clear Dropzone after successful upload
          this.fileAdded = false; // Reset the file added flag

          this.$showSuccess('errors.Success_image_updated_successfully');

          this.$router.push({ path: `/user/edit/${this.state.id}` }).then(() => {
            this.fetchUserData(this.state.id); 
          });

        } catch (error) {
          console.error('Error uploading image:', error);
          this.$showError('errors.Contact_system_admin');          
        }
      } else {
        console.error('No image selected for upload.');
        this.$showError('errors.No_image_selected_for_upload');        
      }

      this.$store.commit('setShowLoading', false);
    },    
    async updateUserInfo() {
      try {
        this.$store.commit('setShowLoading', true);

        this.vrulesUserDetails$.$validate();
        console.log(this.vrulesUserDetails$.$error);
        //if (this.vrulesUserDetails$.$error) {
        //  console.log(this.vrulesUserDetails$.$errors); // this gives an array of all errors
        //}

        if(this.state.userStartDate === '') {
          this.state.userStartDate = null;
        }
        if(this.state.userEndDate === '') {
          this.state.userEndDate = null;
        }
        
        if (!this.vrulesUserDetails$.$error) {
          const response = await axios.put('user/updateinfo', {

          'id': this.state.id,
          'aspNetUserId': this.state.aspNetUserId,          
          'roleName': this.state.roleName,
          //'prefix': this.state.prefix,
          'initials': this.state.initials,
          'firstName': this.state.firstName,
          'middleName': this.state.middleName,
          'lastName': this.state.lastName,
          'mobileNumber': this.state.mobileNumber,
          'email': this.state.email,
          'phoneNumber': this.state.phoneNumber,
          'inspectorId': this.state.inspectorId,
          'shareTelephone': this.state.shareTelephone,
          'shareAddress': true,
          'shareEmail': this.state.shareEmail,
          'shareName': this.state.shareName,
          'rvoConnection': this.state.rvoConnection,
          'rvoRelationnumber': this.state.rvoRelationnumber,
          'gdConnection': this.state.gdConnection,
          'studbookCode': this.state.studbookCode,
          'userStartDate': this.state.userStartDate,
          'userEndDate': this.state.userEndDate,
        });
        this.gets = response.data;

        if (this.gets.success) {
          this.$showSuccess('errors.Success_User_info_updated_successfully');

          this.$router.push({ path: `/user/edit/${this.state.id}` }).then(() => {
            this.fetchUserData(this.state.id); 
          });

        } else {
          this.$showError('errors.Contact_system_admin');
        }
      }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      } finally {
        this.$store.commit('setShowLoading', false);
      }      
    },
    async updateAddress() {
      try {
        this.$store.commit('setShowLoading', true);

        this.vAddress$.$validate();
        console.log(this.vAddress$.$error);

        if (!this.vAddress$.$error) {
          const response = await axios.put('user/updateaddress', {

          'id': this.state.id,
          'address': this.state.address,
          'houseNumber': this.state.houseNumber,
          'city': this.state.city,
          'zipcode': this.state.zipcode,
          'country': this.state.country          
        });
        this.gets = response.data;

        if (this.gets.success) {
          this.$showSuccess('errors.Success_User_address_updated_successfully');

          this.$router.push({ path: `/user/edit/${this.state.id}` }).then(() => {
            this.fetchUserData(this.state.id); 
          });

        } else {
          this.$showError('errors.Contact_system_admin');
        }
      }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      }
      this.$store.commit('setShowLoading', false);
    },
    async updatePassword() {              
        try {
          this.$store.commit('setShowLoading', true);
          
          const response = await axios.put('user/updatepassword', {
            aspNetUserId: this.state.aspNetUserId,
            newPassword: this.password
          });
          this.gets = response.data;

          if (this.gets.success) {
            this.$showSuccess('errors.Success_User_password_updated_successfully');

            // clear form
            this.password = '';
            this.confirmPassword = '';
            this.validateAll();

            this.$router.push({ path: `/user/edit/${this.state.id}` }).then(() => {
              this.fetchUserData(this.state.id); 
            });
          } else {
            this.$showError('errors.Contact_system_admin');
          }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
    },
    confirmDelete() {
      this.state.deleteUserAccount = !this.state.deleteUserAccount;
    },
    deactivateAccount() {
      if (this.state.deleteAccount) {
        this.deactivateUser(this.state.aspNetUserId)
      } else {
        this.$swal.fire({
          text: "Please confirm before deactivating.",
          icon: "warning",
        });
      }
    },
    deleteAccount() {
      if (this.state.deleteUserAccount) {
        this.deleteUser(this.state.aspNetUserId)
      } else {
        this.$swal.fire({
          text: "Please confirm before deleting.",
          icon: "warning",
        });
      }
    },    
    async deactivateUser(aspNetUserId) {
      try {
        
        this.$store.commit('setShowLoading', true);

        const response = await axios.put("User/deactivate/" + aspNetUserId);
        this.gets = response.data;

        if (this.gets.success) {
          this.$showSuccess('errors.Success_user_deactivated_successfully');
          this.$router.push({ path: `/user/edit/${this.state.aspNetUserId}` }).then(() => {
            this.fetchProfileData(this.state.id);
          });
        } else {
          this.$showError('errors.Contact_system_admin');
        }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      }
    },
    async deleteUser(aspNetUserId) {
      try {
        
        this.$store.commit('setShowLoading', true);

        const response = await axios.put("User/delete/" + aspNetUserId);
        this.gets = response.data;

        if (this.gets.success) {
          this.$showSuccess('errors.Success_user_deleted_successfully');          
          this.$router.push('/user');
        } else {
          this.$showError('errors.Contact_system_admin');
        }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      }
    }
  }
};
</script>
<style scoped>
  .avatar img {
    width: 80%;
  }
  .password-input-wrapper {
  position: relative;
  width: 100%;
}

.password-input {
  width: 100%;
  padding-right: 2.5rem; /* Reserve space for the icon */
  border: none;
  border-bottom: 1px solid #ccc;
  outline: none;
}

.password-input:focus {
  border-bottom-color: green; /* or your primary color */
}

.toggle-icon {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>